import { Component, OnInit } from '@angular/core';
import { AwardService } from '../../../../core/services/awards/awards.service';
import { Router } from '@angular/router';
declare const bootstrap: any;


@Component({
    selector: 'app-all-awards',
    templateUrl: './all-awards.component.html',
    styleUrls: ['./all-awards.component.scss']
})
export class AllAwardsComponent implements OnInit {
    allWinners: any;
    selectedCategory: any = 0;
    headerName: any = 'All awardees'
    allWinnersCopy: any;
    awardSelection:any;
    version:any=[];
    allVersions:any=[];
    isArchive:boolean=false;
    descriptionDetails:any;
    isDescriptionExpanded:any;

    constructor(public awardsService: AwardService, private router: Router) { }

    ngOnInit(): void {
        if(this.router.url.includes('/archive')){
            this.isArchive = true;
        this.getAllVersion()

        }

        this.awardsService.getAllAwardsWinner().subscribe((res) => {
            this.allWinners = res.awardWinners;
            this.allWinners.forEach((element,index) => {
                if(this.isTextLong(element.winner)){
                    this.allWinners[index].isShowReadMoreWinner = true;
                }
            });
            console.log(this.allWinners)
            this.allWinnersCopy = res.awardWinners;
        }, err => {

        })
    }

    isTextLong(text: string): boolean {
        return text.length > 40;
    }

    onSelectIndex(event) {
        this.selectedCategory = event;
        switch (event) {
            case 0:
                this.allWinners = this.allWinnersCopy;
                this.headerName = 'All awardees'
                break;
            case 1:
                this.allWinners = this.allWinnersCopy.filter((v) => v.category == "audience" || v.category == 'Audience');
                this.headerName = 'Audience'
                break;
            case 2:
                this.allWinners = this.allWinnersCopy.filter((v) => v.category == "jury");
                this.headerName = 'Jury'
                break;
        }
    }

    onChangeCategory(event: any) {
        this.awardSelection = event;
    }

    goToLink(url: string, type?:any){
        if(type === 'Jury'){
            window.open(url);
        }else{
            if (/(http(s?)):\/\//i.test(url)) {
                window.open(url, "_blank");
            } else {
                window.open(`https://${url}`);
            }
        }

    }

    onChangeVersion(event:any){
        let version = this.allVersions.find((v: any) => (parseInt(v.id) === parseInt(this.version)))
        this.awardsService.setVersion(version);
        this.awardsService.getArchivedWinnersByVersion(version.awardsVersion).subscribe(data=>{
            this.allWinners = data.awardWinners;
            this.allWinnersCopy = data.awardWinners;
            this.allWinners.forEach((element, index) => {
                if (this.isTextLong(element.winner)) {
                    this.allWinners[index].isShowReadMoreWinner = true;
                }
            });
            this.selectedCategory = 0;
        },err=>{
            alert("Error while fetching data")
        })
    }

    getAllVersion() {
        this.awardsService.getAllAwardsVersion().subscribe(data => {
            //Checking if current page is Archive, don't show Current version else show Current version.
            if (this.isArchive) {
                const archiveVersions = data.awardsVersions.filter(v => v.isCurrent === 0);
                this.allVersions = archiveVersions;
                const maxVersion = archiveVersions.reduce((prev, current) =>
                    Number(prev.awardsVersion) > Number(current.awardsVersion) ? prev : current
                ); //Setting the version to the biggest number
                //Checking for any pre-set data
                if(this.awardsService.getVersion()) this.version = this.awardsService.getVersion().id;
                else this.version = maxVersion?.id;
                this.onChangeVersion(this.version);
              } else {
                this.allVersions = data.awardsVersions;
                const currentVersion = this.allVersions.find(v => v.isCurrent === 1);
                this.version = currentVersion?.id;
              }
        }, err => {

        })
    }

    getTruncatedText(text: string): string {
        return text.length > 40 ? text.substring(0, 40) + '...' : text;
    }

    onClickOfDescription(event:Event,item:any){
        event.stopPropagation()
        this.descriptionDetails = item.winner;
        const modalElement = document.getElementById('movieDescription');
        const bootstrapModal = new bootstrap.Modal(modalElement);
        bootstrapModal.show();
    }

}